import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  root: {
    textAlign: 'left',
    width:' 90%',
    margin: 'auto',
    display: 'flex',
    padding: '2em',
    flexDirection: 'column'
  }
});

export default useStyles;
